import React from "react";
import { ButtonText } from "@loanbossinc/component-library";
import { Edit } from "@material-ui/icons";
import styled from "styled-components/macro";
import { ROUTE_CAMPAIGNS } from "constants/routes";

import { EdcProgressStepper, PAGE_PADDING_WIDTH } from "..";

const Wrapper = styled.div`
  height: 156px;
  border: 1px solid #DADCE0;
  box-shadow: 0px 10px 20px 0px #ADAEAE40;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  background-color: #FAFAFA;
  font-family: Work Sans;
  padding: 0.5em ${PAGE_PADDING_WIDTH};
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  gap: 1.5em;
  padding: 0.5em 0;
  width: 100%;
  max-width: calc((100vw - (2 * ${PAGE_PADDING_WIDTH})) * 0.3);
`;

const NameAndCreatedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

const NameEditWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  gap: 1em;
`;

const NameText = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  color: #000000;
`;

const StyledEditIcon = styled(Edit)`&& {
  color: #005AA9;
  cursor: pointer;
  font-size: 20px;
}`;

const CreatedAtText = styled.div`
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  color: #5F6368;
`;

const StyledButtonText = styled(ButtonText)`&& {
  padding: 0;
  height: 30px;
  width: 180px;

  && > span {
    gap: 0.5em;
    justify-content: flex-start;
  }
}`;

const BodyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc((100vw - (2 * ${PAGE_PADDING_WIDTH})) * 0.5);
`;

const EdcProgressBanner = ({
  name,
  handleEditNameIconClick,
  campaignSteps,
  activeStep,
  setActiveStep,
  campaignCategory,
  createdAt,
  backToDashboardClick
}) => (
  <Wrapper>
    <TextSection>
      <StyledButtonText
        reverse
        iconName="arrow_forward"
        label="Back to dashboard"
        onClick={backToDashboardClick}
      />
      <NameAndCreatedWrapper>
        <NameEditWrapper>
          <NameText>{name}</NameText>
          <StyledEditIcon onClick={handleEditNameIconClick} />
        </NameEditWrapper>
        <CreatedAtText>{createdAt}</CreatedAtText>
      </NameAndCreatedWrapper>
    </TextSection>
    <BodyContainer>
      <EdcProgressStepper
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        campaignSteps={campaignSteps}
        campaignCategory={campaignCategory}
      />
    </BodyContainer>
    { }
  </Wrapper>
);

export default EdcProgressBanner;

